import util from '@bmp-vue/core/api/util'

const controller = 'EnvioRecepcao'
export default Object.assign({}, util.GetCrud(controller, ['getall', 'get', 'put', 'delete']), {   
    GetRelatorioEnvioRecepcaoPorDataOuNome(dto){
        return util.Axios.GetAll(`${controller}/GetRelatorioEnvioRecepcaoPorDataOuNome`, dto)
    }
})
